var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoFacebook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1593 0.00416134L9.35301 0C6.20024 0 4.16278 1.9319 4.16278 4.92202V7.19141H1.34117C1.09735 7.19141 0.899902 7.37409 0.899902 7.59942V10.8875C0.899902 11.1128 1.09757 11.2953 1.34117 11.2953H4.16278V19.5923C4.16278 19.8175 4.36022 20 4.60404 20H8.28543C8.52926 20 8.7267 19.8174 8.7267 19.5923V11.2953H12.0258C12.2696 11.2953 12.4671 11.1128 12.4671 10.8875L12.4684 7.59942C12.4684 7.49124 12.4218 7.38761 12.3392 7.31105C12.2566 7.23448 12.144 7.19141 12.0269 7.19141H8.7267V5.26762C8.7267 4.34297 8.96511 3.87357 10.2684 3.87357L12.1589 3.87295C12.4025 3.87295 12.5999 3.69027 12.5999 3.46514V0.411973C12.5999 0.187053 12.4027 0.00457746 12.1593 0.00416134Z",
    fill: "#3753A4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoFacebook);
export default __webpack_public_path__ + "static/media/ico-facebook.9a97e2cb.svg";
export { ForwardRef as ReactComponent };